<template>

</template>

<script>
export default {
  name: 'View',

  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

};
</script>

<style scoped>

</style>
